module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"links":{"portfolio":"Liegenschaften","report":"Absenkpfad","reida":"Reporting","scenario":"Szenarien","settings":"Einstellungen","license":"Lizenz","import":"Import & Export","account":"Account","portfolioImport":"Portfolio importieren","management":"Verwaltung"},"simulationInProgress":"Berechnung läuft","buildingsInQueue":"{n} Liegenschaft | {n} Liegenschaften"}}')
  delete Component.options._Ctor
}
